import React from "react";

import styles from "./SpinnerQ.module.css";

const SpinnerQ = ({category = "sterilization"}) => {
  let color = category.toLowerCase() === "dispatch" ? styles.dispatch : ""
  return <span className={`${styles.loader} ${color}`}></span>;
};

export default SpinnerQ;
